import { GetDisplayGroup, GetDisplayGroupVariables } from './__generated__/GetDisplayGroup'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

export const GET_DISPLAY_GROUP_QUERY = gql`
  query GetDisplayGroup($id: String!) {
    getDisplayGroup: getDisplayGroupV2(id: $id) {
      ... on DisplayGroupErrorV2 {
        type
        error
      }
      ... on DisplayGroupV2 {
        id
        title
        displayDelay
        rows
        columns
        ownerId
        createdAt
        updatedAt
        boardStyle
        boards {
          id
          board {
            id
            title
            boardStyle
            pairedDevice {
              id
              firmwareVersion
              pairingCode
            }
          }
        }
        roles {
          id
          personId
          role
          createdAt
          person {
            id
            firstName
            lastName
            emailAddress
          }
        }
        invites {
          id
          email
          role
          createdAt
        }
        outgoingWebhooks {
          id
          url
          token
          installableId
        }
      }
    }
  }
`

export const useGetDisplayGroup = (id: string) => {
  return useQuery<GetDisplayGroup, GetDisplayGroupVariables>(GET_DISPLAY_GROUP_QUERY, {
    variables: { id },
    skip: !id
  })
}
